export class Client {
	
	constructor() {
		let url = new URL(window.location.href);
		this.mid = 15;
		this.id = 0;
	}

	updateLog()
	{
		
		$.ajax({
			url: "/ajax.php?mid=13",
			type: 'POST',
			data: {
				action: 'request_new',
				kpp: kpp,
				last: last
				},
			dataType: "json",
			success: function(res){
				if (res['items'])
				{
					for(var i = 0; i < res['items'].length; i++)
					{
						addItem(res['items'][i]);
					}
				}
				else
				{
					
				}
				
				setTimeout(function(){
					updateLog();
				}, 5000);
			},
			error: function(err){
				setTimeout(function(){
					updateLog();
				}, 5000);
			}
		});
	}

	flush_b24(id)
	{
		 $.ajax({
			url: "/vsop/ajax/15/",
			type: 'POST',
			data: {
				action: 'flush_b24',
				id: id
			},
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					location.reload();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(err){
				alert('Ошибка: ' + err);
			}
		});
	}

	delCarpass(id, parent)
	{
		 if (confirm('Вы хотите удалить пропуск?'))
		 {
		 	var li = $(parent).closest('li');

		 	$.ajax({
				url: "/vsop/ajax/13/",
				type: 'POST',
				data: {
					action: 'del',
					id: id,
					},
				dataType: "json",
				success: function(res){
					if (res['success'])
					{
						li.fadeOut();
					}
					else
					{
						alert('Ошибка: ' + res['error']);
					}
				},
				error: function(err){
					alert('Ошибка: ' + err);
				}
			});
		 }

		 return false;
	}

	delCarphone(id, parent)
	{
		 if (confirm('Вы хотите удалить пропуск?'))
		 {
		 	var li = $(parent).closest('li');

		 	$.ajax({
				url: "/vsop/ajax/13/",
				type: 'POST',
				data: {
					action: 'del_phone',
					id: id,
					},
				dataType: "json",
				success: function(res){
					if (res['success'])
					{
						li.fadeOut();
					}
					else
					{
						alert('Ошибка: ' + res['error']);
					}
				},
				error: function(err){
					alert('Ошибка: ' + err);
				}
			});
		 }

		 return false;
	}

	delCarrfid(id, parent)
	{
		 if (confirm('Вы хотите удалить метку?'))
		 {
		 	var li = $(parent).closest('li');

		 	$.ajax({
				url: "/vsop/ajax/13/",
				type: 'POST',
				data: {
					action: 'del_fid',
					id: id,
					},
				dataType: "json",
				success: function(res){
					if (res['success'])
					{
						li.fadeOut();
					}
					else
					{
						alert('Ошибка: ' + res['error']);
					}
				},
				error: function(err){
					alert('Ошибка: ' + err);
				}
			});
		 }

		 return false;
	}

	carpasses_trans(from, to)
	{
		 if (confirm('Вы хотите перенести все пропуска на открытый ЛС?'))
		 {

		 	$.ajax({
				url: "/vsop/ajax/15/",
				type: 'POST',
				data: {
					action: 'carpasses_trans',
					from: from,
					to: to,
				},
				dataType: "json",
				success: function(res){
					if (res['success'])
					{
						console.log(from);
						console.log(to);
						var li_from = $('#carpasses_list ul[data-account=' + from + '] li');
						var ul_to = $('#carpasses_list ul[data-account=' + to + ']');

						li_from.fadeOut('normal', function(){
							ul_to.append(li_from);
							li_from.removeClass('inactive');
							li_from.find('span').hide();
							li_from.fadeIn();
						});
						

						$('#carpasses_list ul[data-account=' + from + ']').closest('li').find('>a.btn.trans').fadeOut();
					}
					else
					{
						alert('Ошибка: ' + res['error']);
					}
				},
				error: function(err){
					alert('Ошибка: ' + err);
				}
			});
		 }

		 return false;
	}

	block_pass(id, val, parent)
	{
		 $.ajax({
			url: "/vsop/ajax/15/",
			type: 'POST',
			data: {
				action: 'block_pass',
				id: id,
				val: val
			},
			dataType: "json",
			success: function(res){
				if (!res.success)
				{
					alert(res.error);
				}

				if (res.result == 1)
				{
					$(parent).replaceWith('<a href="#" onclick="block_pass(' + id  + ', 0, this); return false;">разблокировать создание пропусков</a>');
				}
				else
				{
					$(parent).replaceWith('<a href="#" onclick="block_pass(' + id  + ', 1, this); return false;">заблокировать создание пропусков</a>');
				}
			},
			error: function(err){
				alert('Ошибка: ' + err);
			}
		});
	}

	applyEvents()
	{
		$("div#result").append("");

		$('button.generate').click(function(){
			let array = [];
		
			$.each($("input.village"), function(a, b){
				let ischecked= $(this).is(':checked');
				if(ischecked){
					array.push($(this).val());
				}
			});
			if(array.length > 0){
				$.ajax({
					url: "/vsop/ajax/3/",
					type: 'POST',
					data: { array: JSON.stringify(array) },
					dataType: "json",
					success: function(res){

						if(res.status == "OK"){
							
							let link = "<a href='"+res.link+"'>Download</a>";
							//console.log(link);
							$("div#result").append("");
							$("div#result").append(link);
						}
						array = [];	
					},
					error: function(err){
						console.log(err);
					}
				});
			}else{
				alert("не выбрано ни одного посёлка");
			}
		});
	}
}